import React, {Fragment} from 'react';

export default function renderTemplate(tpl, params) {
	if (!Array.isArray(params)) {
		params = [];
	}
	let rest = tpl.trim();
	const ret = [];
	while (true) {
		const m = /\$[0-9]+|\n/.exec(rest);
		if (!m) {
			break;
		}
		let item;
		if (m[0].startsWith('$')) {
			const i = parseInt(m[0].substring(1), 10) - 1;
			item = params[i] || <span className="slx-mounting-template--missing">?</span>;
		} else {
			item = <br />;
		}
		if (m.index !== 0) {
			ret.push(rest.substring(0, m.index));
		}
		ret.push(item);
		rest = rest.substring(m.index + m[0].length);
	}
	return React.createElement(Fragment, null, ...ret, rest);
}
